export default "__VITE_ASSET__snOMwN6z__"